module.exports = __webpack_public_path__ + "img/226.213731a7.png";